import * as Types from '../../../generated/gqlTypes';

import { gql } from '@apollo/client';
export type ProductsDataFileFragment = { id: string, pk: number, created: any, resultFile: string | null };

export const ProductsDataFileFragmentDoc = gql`
    fragment ProductsDataFileFragment on ProductsDataFileType {
  id
  pk
  created
  resultFile
}
    `;